import { 
  CONTACT_PAGE_URL, 
  HOME_PAGE_URL, 
  COMMERCIALS_PAGE_URL, 
  WELLNESS_PAGE_URL, 
  ABOUT_PAGE_URL, 
  REVIEWS_PAGE_URL 
} from '../Routes';

export const FooterLinksArray = [
  {
    name: 'Home',
    route: HOME_PAGE_URL
  },
  {
    name: 'Commercials',
    route: COMMERCIALS_PAGE_URL
  },
  {
    name: 'Wellness',
    route: WELLNESS_PAGE_URL
  },
  {
    name: 'About',
    route: ABOUT_PAGE_URL
  },
  {
    name: 'Reviews',
    route: REVIEWS_PAGE_URL
  },
  {
    name: 'Contact',
    route: CONTACT_PAGE_URL
  },
];
